import React, { useContext } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';

import classNames from 'classnames';

import { Button } from 'semantic-ui-react';

import { SatCoreComponent, SatCoreRegister } from '../SatCoreRegistry';
import { STUDENT_PROGRESS_WIDGET } from '../constants';

import '../css/StudentDashboardProgressWidget.less';

const StudentDashboardProgressWidget = observer((props = {}) => {
  const {
    disabled,
    loading,
    showProgress,
    t,
    widgetKey = STUDENT_PROGRESS_WIDGET.StudentProgressTrophiesWidget // default, can pass different widgetKey
  } = props;

  const { /* managers */ } = useContext(MobXProviderContext);

  const StudentProgressBarWidget = SatCoreComponent('StudentProgressBarWidget');
  const StudentProgressSummaryChartWidget = SatCoreComponent('StudentProgressSummaryChartWidget');
  const StudentProgressTrophiesWidget = SatCoreComponent('StudentProgressTrophiesWidget');
  const StudentProgressWeeklyPerformanceChartWidget = SatCoreComponent('StudentProgressWeeklyPerformanceChartWidget');

  const ariaLabelProgressWidgetOpenButton = t(`ariaLabelProgressWidgetOpenButton_${widgetKey}`);
  const progressWidgetTitleLabel = t(`myProgress_${widgetKey}`);

  const renderStudentProgressWidgetInner = () => {
    switch (widgetKey) {
      case STUDENT_PROGRESS_WIDGET.StudentProgressSummaryChartWidget:
        return (
          <StudentProgressSummaryChartWidget loading={loading} onlyRenderInnerWidgetContent={true} />
        );
      case STUDENT_PROGRESS_WIDGET.StudentProgressBarWidget:
        return (
          <StudentProgressBarWidget loading={loading} onlyRenderInnerWidgetContent={true} />
        );
      case STUDENT_PROGRESS_WIDGET.StudentProgressWeeklyPerformanceChartWidget:
        return (
          <StudentProgressWeeklyPerformanceChartWidget loading={loading} onlyRenderInnerWidgetContent={true} />
        );
      case STUDENT_PROGRESS_WIDGET.StudentProgressTrophiesWidget:
        return (
          <StudentProgressTrophiesWidget loading={loading} onlyRenderInnerWidgetContent={true} />
        );
      default:
        return null;
    }
  };

  return (
    <div className={classNames(`dashboard-widget__${widgetKey}`,
      'StudentDashboardProgressWidget',
      'dashboard-widget',
      'student-dashboard-widget-progress',
      'orange',
      'progress'
    )} tabIndex='0'>
      <h2 aria-label={`${progressWidgetTitleLabel}`} className='w-title' tabIndex='0'>
        {progressWidgetTitleLabel}
      </h2>
      <div className={`w-content w-content__${widgetKey}`}>
        {renderStudentProgressWidgetInner()}
        <div className='actions'>
          <Button
            aria-label={ariaLabelProgressWidgetOpenButton}
            disabled={disabled}
            onClick={showProgress}
            primary
            type='button'>
            {t('open')}
          </Button>
        </div>
      </div>
    </div>
  );
});

export default StudentDashboardProgressWidget;

SatCoreRegister('StudentDashboardProgressWidget', StudentDashboardProgressWidget);
